export default __webpack_public_path__ + "static/media/img1.98f1a61c.jpg";